import { render, staticRenderFns } from "./GroupBuyingsList.vue?vue&type=template&id=6ae88802&scoped=true&"
import script from "./GroupBuyingsList.vue?vue&type=script&lang=js&"
export * from "./GroupBuyingsList.vue?vue&type=script&lang=js&"
import style0 from "./GroupBuyingsList.vue?vue&type=style&index=0&id=6ae88802&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae88802",
  null
  
)

export default component.exports